import UAParser from 'ua-parser-js';

/**
 * Détecte si l'utilisateur est sur un mobile Apple (iPhone ou iPad), que l'app
 * tourne en natif via Capacitor ou en navigateur web (Safari iOS / iPadOS).
 *
 * À ne pas confondre avec `window.env.isIos` (alimenté par `Capacitor.getPlatform()`)
 * qui ne vaut `true` qu'en app native Capacitor iOS et reste `false` en Safari iOS web.
 *
 * @returns {boolean}
 */
export const isAppleMobileDevice = () => {
  if (window.env?.isIos) return true;
  if (new UAParser().getOS().name === 'iOS') return true;
  // iPadOS 13+ ment dans son UA (Macintosh) — UAParser le voit donc comme macOS.
  // On s'appuie sur l'heuristique platform=MacIntel + maxTouchPoints>1.
  // navigator.platform est "deprecated" par la spec mais Safari ne propose pas
  // d'alternative stable.
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
};
